/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import { Flex } from 'atomic'
/* --------------------------- Styled Component ----------------------------- */
export default props => <Flex {...props} />


// WEBPACK FOOTER //
// ./src/interface/atomic/atoms/Flex/index.js